import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import { BrandingProvider } from './contexts/BrandingContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';

// Sofbox template styles (Bootstrap 4 + iq-* design system)
import './assets/scss/style.scss';
// BS5→BS4 compatibility shim for feature pages
import './assets/css/bs5-compat.css';
// Mobile polish for public marketplace pages (home, search, listing
// detail, host profile). Only takes effect below a handful of media
// query breakpoints — no impact on desktop.
import './assets/css/mobile-public.css';
// WareShare brand pass — ports the mobile ui-kit tokens to the web
// (Inter font, brand palette, gradients, elevation, component
// overrides for cards/buttons/tables/sidebar). Imported LAST so it
// overrides the Sofbox template defaults above.
import './assets/css/wareshare-theme.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <BrandingProvider>
          <LanguageProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </LanguageProvider>
        </BrandingProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
